import React from "react";
import styles from './EvaluationStudentCard.module.scss';
import EvaluationProgress from "../evaluationProgress/EvaluationProgress";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const EvaluationStudentCard = ({
  data,
  count,
  cta,
  disabled = false
}) => {
  return (
    <div className={`${styles.card}${disabled ? ` ${styles.disabled}` : ''}`}>
      <div className={styles.content}>
        <div className={styles.data}>
          {data.map((item) => (
            <div className={styles.dataItem} key={item.label}>
              <label>{item.label}</label>
              <span className={styles.textRow}>
                <span className={item.color && styles[item.color] ? styles[item.color] : ''}>
                  {item.text}
                </span>
                {item.tag && <span className={styles.tag}>{item.tag}</span>}
              </span>
            </div>
          ))}
        </div>
        <div className={styles.chart}>
          <EvaluationProgress {...count} />
        </div>
      </div>
      {cta && <div className={styles.cta}>
        <Link to={cta.link}>{cta.label}</Link>
      </div>}
    </div>
  );
};

EvaluationStudentCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      color: PropTypes.oneOf(['red', 'green']),
    })
  ).isRequired,
  count: PropTypes.shape({
    total: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired
  }),
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired
  }),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default EvaluationStudentCard;